import { Temporal } from '@js-temporal/polyfill';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { JobsiteProps } from '../types.ts';

import { JobsiteFieldDisplay } from '../JobsiteFieldDisplay.tsx';

const JobsiteDetails = ({
  jobsiteId,
  jobsiteName,
  jobsiteAddress,
  jobsiteDescription,
  supervisorName,
  defaultWorkStartTime,
  defaultWorkEndTime,

  showJobsiteId = true,
}: JobsiteProps) => {
  supervisorName && true;

  let jobsiteDisplayFields = [
    { title: 'ID', value: jobsiteId },
    { title: 'Name', value: jobsiteName },
    { title: 'Address', value: jobsiteAddress },
    { title: 'Description', value: jobsiteDescription },
    // { title: 'Supervisor', value: supervisorName },
    { title: 'Typical start', value: defaultWorkStartTime },
    { title: 'Typical end', value: defaultWorkEndTime },
  ];

  if (!showJobsiteId) {
    jobsiteDisplayFields = jobsiteDisplayFields.filter(field => field.title !== 'ID');
  }

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',

        width: '100%',
        marginLeft: 0,

        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',

        '& .field-display': {
          padding: '0.6em 0',
          backgroundColor: 'white',
        },

        '& .field-display+.field-display': {
          borderTop: '1px solid #ccc',
        },
        '& .field-display:first-of-type, .field-display:first-of-type > p': {
          borderTopLeftRadius: '4px',
          borderTopRightRadius: '4px',
        },
        '& .field-display:last-of-type, .field-display:last-of-type > p': {
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
        },
      }}
    >
      {jobsiteDisplayFields.map(jobsiteField => (
        <JobsiteFieldDisplay
          key={jobsiteField.title}
          title={jobsiteField.title}
          value={
            jobsiteField.value instanceof Temporal.PlainTime
              ? jobsiteField.value
                .toLocaleString('en-US', {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true,
                })
                .toLowerCase()
              : jobsiteField.value
          }
        />
      ))}
    </Box>
  );
};

export default JobsiteDetails;
